import { updateKeyInStore } from 'App';
import * as Yup from 'yup';
import { OwnersStateValues, updateKey, updateFieldArrayKey } from './slice';
import { store } from 'app/redux/store';
import { states } from 'states';
import { countries } from 'countries';
import { Validators } from 'utils/Validators';

export const fields: TInput<keyof OwnersStateValues>[] = [
  {
    name: 'OwnersList',
    label: 'Owners List',
    type: 'fieldArray',
    effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
    tooltip: '',
    comment: true,
    defaultDependency: {},
    dependencies: [
      {
        name: 'firstName',
        label: 'First Name',
        type: 'text',
        effect: updateKeyInStore(updateKey),
        tooltip: '',
        comment: true,
      },
      {
        name: 'lastName',
        label: 'Last Name',
        type: 'text',
        effect: updateKeyInStore(updateKey),
        tooltip: '',
        comment: true,
      },
      {
        name: 'OfOwnership',
        label: '% of Ownership',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        tooltip: '',
        comment: true,
      },
      {
        name: 'socialSecurityNumber',
        label: 'Social Security Number',
        type: 'maskedInput',
        mask: '999-99-9999',
        effect: updateKeyInStore(updateKey),
        tooltip: '',
        comment: true,
      },
      {
        name: 'address',
        label: 'Address',
        type: 'text',
        effect: updateKeyInStore(updateKey),
        tooltip: '',
        comment: true,
      },
      {
        name: 'city',
        label: 'City',
        type: 'text',
        effect: updateKeyInStore(updateKey),
        tooltip: '',
        comment: true,
      },
      {
        name: 'state',
        label: 'State',
        type: 'state',
        effect: updateKeyInStore(updateKey),
        tooltip: '',
        comment: true,
      },
      {
        name: 'zipCode',
        label: 'Zip Code',
        type: 'text',
        effect: updateKeyInStore(updateKey),
        tooltip: '',
        comment: true,
      },
      {
        name: 'country',
        label: 'Country',
        type: 'country',
        effect: updateKeyInStore(updateKey),
        tooltip: '',
        comment: true,
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({
  OwnersList: Yup.array(
    Yup.object().shape({
      firstName: Yup.string().nullable().required('Required'),
      lastName: Yup.string().nullable().required('Required'),
      OfOwnership: Yup.string().nullable().required('Required'),
      socialSecurityNumber: Yup.string().nullable().required('Required'),
      address: Yup.string().nullable().required('Required'),
      city: Yup.string().nullable().required('Required'),
      state: Yup.string().nullable().required('Required'),
      zipCode: Validators.zipCode.required('required'),
      country: Yup.string().nullable().required('Required'),
    }),
  ),
});
/*

 

*/
